const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');
const Cast = require('../../util/cast');
const Scratch3LooksBlocks = require('../../blocks/scratch3_looks');
const uid = require('../../util/uid');
const menuIconURI = "data:image/png;base64,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"

class PythonRandomBlocks {
    constructor(runtime) {
        if (!runtime) {
            throw new Error('Runtime is required for PythonStatementsBlocks');
        }
        this.runtime = runtime;
    }

    getInfo() {
        return {
            id: "pythonRandom",
            color1: '#2ec4b6',
            name: "Python Random",
            menuIconURI: menuIconURI,
            blockIconURI: menuIconURI,
            blocks: [
                {
                    opcode: 'getRandomLetter',
                    blockType: 'reporter',
                    text: 'random.choice([STRING])',
                    arguments: {
                        STRING: {
                            type: 'string',
                            defaultValue: 'Hello'
                        }
                    }
                },

                {
                    opcode: 'getRandomIntBetween',
                    blockType: 'reporter',
                    text: 'random.randint([MIN], [MAX])',
                    arguments: {
                        MIN: {
                            type: 'number',
                            defaultValue: 1
                        },
                        MAX: {
                            type: 'number',
                            defaultValue: 10
                        }
                    }
                },

                {
                    opcode: 'getRandomFloat',
                    blockType: 'reporter',
                    text: 'random.random ( )',
                    arguments: {}
                },

                {
                    opcode: 'getRandomFloatBetween',
                    blockType: 'reporter',
                    text: 'random.uniform([MIN], [MAX])',
                    arguments: {
                        MIN: {
                            type: 'number',
                            defaultValue: 20
                        },
                        MAX: {
                            type: 'number',
                            defaultValue: 30
                        }
                    }
                }
            ],
            menus: {
                // No menus needed for this block
            }
        };
    }

    getRandomLetter(args) {
        const str = args.STRING.toString();
        if (str.length === 0) {
            return '';
        }
        const randomIndex = Math.floor(Math.random() * str.length);
        return str.charAt(randomIndex);
    }

    getRandomIntBetween(args) {
        // Convert arguments to numbers and round them
        let min = Math.floor(Number(args.MIN));
        let max = Math.floor(Number(args.MAX));
        
        // Swap if min is greater than max
        if (min > max) {
            [min, max] = [max, min];
        }
        
        // Generate random integer between min and max (inclusive)
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    getRandomFloat() {
        // Generate random float between 0.0 and 1.0
        return Math.random();
    }

    getRandomFloatBetween(args) {
        // Convert arguments to numbers
        let min = Number(args.MIN);
        let max = Number(args.MAX);
        
        // Swap if min is greater than max
        if (min > max) {
            [min, max] = [max, min];
        }
        
        // Generate random float between min and max
        const range = max - min;
        return min + (Math.random() * range);
    }
}

module.exports = PythonRandomBlocks;